export default function LockIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="#FFF5F4" />
      <path
        d="M12 1.5C13.6569 1.5 15 2.84315 15 4.5V10.5H9V4.5C9 2.84315 10.3431 1.5 12 1.5ZM16.5 10.5V4.5C16.5 2.01472 14.4853 0 12 0C9.51472 0 7.5 2.01472 7.5 4.5V10.5C5.84315 10.5 4.5 11.8431 4.5 13.5V21C4.5 22.6569 5.84315 24 7.5 24H16.5C18.1569 24 19.5 22.6569 19.5 21V13.5C19.5 11.8431 18.1569 10.5 16.5 10.5Z"
        fill="#FF574D"
      />
    </svg>
  );
}
